<template>
  <div class="product-container" id="container">
    <nav class="nav-header">
      <p
        @click="$router.push({ name: 'company-admin-dids-local-did' })"
        :class="
          $route.name === 'company-admin-dids-local-did' ||
          $route.name === 'company-admin-dids-toll-free' ||
          $route.name === 'company-admin-dids-buy-tf-did' ||
          $route.name === 'company-admin-dids-buy-did'
            ? 'active'
            : ''
        "
        class="first"
      >
        All DIDs
      </p>
      <!-- <p @click="$router.push({name: 'company-admin-dids-suppression'})"
          :class="($route.name === 'company-admin-dids-suppression') ? 'active' : ''">Suppression</p> -->


        <div
                v-if="$route.name === 'company-admin-dids-buy-tf-did'"
                @click="$router.push({name: 'company-admin-dids-toll-free'})" class="back-link ml-sm-3">
          <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
            <path
                    d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
                    id="path-1"
            />
          </svg>
          <p style="white-space: nowrap">Back to DIDs</p>
        </div>

    </nav>
    <router-view class="router-container" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
  .back-link {
    cursor: pointer;
    display: flex;
    align-items: center;
    fill: #51a3f3;
    color: #51a3f3;
    font-family: "Helvetica Neue";
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    p {
      color: #51a3f3 !important;
      margin-bottom: 0;
    }
  }
.product-container {
  padding: 0 20px;
}
.product-container .nav-header {
  margin: 0 -20px;
}
.product-container {
  .nav-header {
    height: 50px;
    background-color: #fff;
    // padding: 0px 20px 0px 20px;
    display: flex;
    p {
      cursor: pointer;
      width: auto;
      height: calc(100% - 2px);
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 0;
      color: #bdbfd8;
      font-family: "" Helvetica Neue "";
      font-size: 16px;
      font-weight: 300;
      line-height: 20px;
      text-align: center;
      padding: 0 16px;
    }
    .active {
      color: #51a3f3;
      border-bottom: 2px solid #51a3f3;
    }
    .first {
      margin-left: 15px;
    }
  }
}
</style>

